import { Link } from '@mui/material';

import { mapTextColorToPalette, primaryColors, useModifiedStyleForWeb } from '@savvy/deprecated-shared/theme';
import { XTypography } from '@savvy/deprecated-shared/x-components/x-typography';

import type { XLinkProps } from './types';

export function XLink({ children, href, rel, target = '_blank', onClick, ...props }: XLinkProps) {
  const style = useModifiedStyleForWeb(props.style);
  const color = props.color ? mapTextColorToPalette[props.color] : primaryColors.main;
  return (
    <XTypography {...props} style={{ cursor: 'pointer', ...style }}>
      <Link href={href} onClick={onClick} rel={rel} target={target} style={{ color }}>
        {children}
      </Link>
    </XTypography>
  );
}
